import React from "react";

const DataTable = ({ columns, data }) => {
  return (
    <div className="">
      <table className="table table-striped table-hover text-center table-responsive-sm">
        <thead className="table-dark fs-5 text-center">
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.headerName}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>{row[col.field]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
